export default __webpack_public_path__ + "static/media/hht2_ep17_book_wp_02.747ee097.jpg";